export const SUGGESTIONS_QUERY_KEYS = {
  all: ["user-suggestions"] as const,
  lists: () => [...SUGGESTIONS_QUERY_KEYS.all, "list"] as const,
  list: (params: unknown) =>
    [...SUGGESTIONS_QUERY_KEYS.lists(), JSON.stringify(params)] as const,
  details: () => [...SUGGESTIONS_QUERY_KEYS.all, "detail"] as const,
  detail: (id: string) =>
    [...SUGGESTIONS_QUERY_KEYS.details(), id] as const,
} as const;
